import type { CartLineItemPersonalization } from '~/types';
import { BaseModel } from '~/models/base-model';

export class CartLineItemPersonalizationModel extends BaseModel<CartLineItemPersonalization> {
    senderName = '';
    recipientName = '';
    recipientEmail = '';
    messageToRecipient = '';
}
